async function PostData(url, data) {
    const res = await fetch(url, {
        method: "POST",
        //headers: {'Content-type': "application/json"},
        body: data
    })
    return await res.text();
} export default PostData;